

import {
    postTicketRequest,
    postTicketSuccess,
    postTicketError
} from './faqAction'

import {
    RAISE_TICKET_REQUEST,
} from '../actionType';

import {RAISE_TICKET} from '../../../utils/urls';

import { fetchPost } from '../../../utils/request';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
const stateValueTicket = (state: any) => state.ticket;
function* raiseTicketReq():any {
    const ticketDetails = yield select(stateValueTicket);
    const messageBody = new FormData();
    messageBody.append('message', ticketDetails?.formData?.value.message);
    messageBody.append('customer_id', '16791191');
    messageBody.append('source', 'P2P Customer');
    messageBody.append('topic_id', '308')
    messageBody.append('name', ticketDetails?.formData?.value?.selectedFile?.name ? ticketDetails?.formData?.value?.selectedFile?.name : '')
    messageBody.append('file', ticketDetails?.formData?.value?.selectedFile ? ticketDetails?.formData?.value?.selectedFile : '');
    try {
        const response = yield call(fetchPost, RAISE_TICKET, messageBody);
        if(response.status) {
            yield put(postTicketSuccess(response));
            return true;
        }
        yield put(postTicketError(response));
        return false;
    } catch (error) {
        yield put(postTicketError(error));
    }

}

export default function* faqSaga(){
    yield all([takeLatest(RAISE_TICKET_REQUEST,raiseTicketReq)])
}